interface TextStyleItem {
	tag: string;
	class?: string;
}

export type TextStyle = { [key: string]: TextStyleItem };

const BASE: TextStyle = {
	em: { tag: 'i' },
	strong: { tag: 'b' },
	strike: { tag: 's' },
	del: { tag: 's' },
	ins: { tag: 'u' },
	h1: { tag: 'h2', class: 'layout:h-body' },
	h2: { tag: 'h2', class: 'layout:h-body' },
	h3: { tag: 'h3', class: 'layout:h-body' },
	h4: { tag: 'h4', class: 'layout:h-body' },
	h5: { tag: 'h5', class: 'layout:h-body' }
	// blockquote: { tag: 'blockquote', class: 'text:sm' },
	// figcaption: { tag: 'figcaption', class: 'text:xs' }
};

export const TextStyle = {
	Mini: {
		...BASE,
		p: { tag: 'p', class: 'text:description-mini' }
	},
	Small: {
		...BASE,
		p: { tag: 'p', class: 'text:description-small' }
	},
	Medium: {
		...BASE,
		p: { tag: 'p', class: 'text:description layout:p-body' },
		li: { tag: 'li', class: 'text:description layout:li-body' },
		ul: { tag: 'ul', class: 'layout:ul-body' }
	},
	Large: {
		...BASE,
		p: { tag: 'p', class: 'text:description-large' }
	}
};
